var map = {
	"./en/Partners_Ntatsi": [
		"e2f8",
		"chunk-76b0d9ba"
	],
	"./gr/Partners_Ntatsi": [
		"769c",
		"chunk-c34128c8"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "ce57";
module.exports = webpackAsyncContext;